import { render, staticRenderFns } from "./nav-button.vue?vue&type=template&id=0d39a382&"
import script from "./nav-button.vue?vue&type=script&lang=js&"
export * from "./nav-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports